module.exports = __webpack_public_path__ + "static/media/accident-default-image2.1b23cceb.png";